export default "__VITE_ASSET__BO7F36ED__"